import { Navigate } from 'react-router';

/** Data retention now lives on Organization. Bookmarks still resolve. */
export function RetentionSettingsPage() {
  return <Navigate to="/settings#company" replace />;
}
